<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/package_rule/pageByMaterial" getKey="rows"
                   :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'60%');" type="primary">
          {{$t('xinzeng')}}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger"
                       @click="yt.remove({materialId: materialId,packageRuleId:scope.row.id},
                       '/web/basic/material_package_rule/deleteByMaterialAndPackageRule')">{{$t('shanchu')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
      <div class="dialog-scroller">
        <matter_package_rule_create v-if="yt.isShowEditDialog&&yt.editObj.action == 'xinzeng'" ref="matter_package_rule_create" :materialId="materialId" ></matter_package_rule_create>
      </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeDialog">{{$t('quxiao')}}</el-button>
            <el-button :loading="yt.loading" size="mini"
                       @click="save()" type="primary">
              {{$t('baocun')}}
            </el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
import matter_package_rule_create from '@@/pages/web/base/matter/matter_package_rule_create';

export default {
  name: "web_base_matter_matter_package_rule",
  components: {
    matter_package_rule_create
  },
  data(){
    return {
      columns: [
        { label: 'baozhuangguizebianma', prop: 'code', width: 200, },
        { label: 'baozhuangguizemingcheng', prop: 'name', width: 200, },
        { label: 'beizhu', prop: 'remark', width: 200, },
        { label: 'chuangjianren', prop: 'createByObject.nickname', width: 200, },
        { label: 'chuangjianshijian', prop: 'createTime',type: 'time', width: 200, },
        { label: 'caozuo', type: 'slot', width: 100, fixed: 'right', }
      ],
      materialId:null,
    }
  },
  created() {
    this.materialId = this.$attrs.material.id;
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id,
        pageNum: 1,
        pageSize: 99999
      }
      this.yt.get(1);
      this.yt.isShowPagination = false;
    }, 300)
  },
  methods:{
    closeDialog(){
      // this.$refs.matter_package_rule_create.$refs.yt.$refs.table.clearSelection();
      this.yt.isShowEditDialog = false;
    },
    save(){
      let params = {
        materialId:this.materialId,
        packageRuleList:this.$refs.matter_package_rule_create.selected
      }
      if(params.packageRuleList ==null || params.packageRuleList.length <= 0){
        this.utils.errorMessage(this.$t('zhishaoxuanzeyitiaoguize'));
      }
      this.http.post('/web/basic/material_package_rule/createMultiply',params).then((result) => {
        this.utils.successMessage(this.$t(result.msg));
        this.yt.get(1);
        this.yt.isShowEditDialog = false;
      })
    },
  },
}
</script>

<style scoped="scoped">

</style>